import { initializeApp, getApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { getAnalytics, isSupported } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyBnoOfOIBdjTob0pkk0V2QntMaR_sKDe0Q",
  authDomain: "site-sync-1007b.firebaseapp.com",
  projectId: "site-sync-1007b",
  storageBucket: "site-sync-1007b.appspot.com",
  messagingSenderId: "921069308574",
  appId: "1:921069308574:web:f425949e4306347a56498f",
  measurementId: "G-WKMVYGM3ND"
};

// Initialize Firebase
let app;
try {
  app = initializeApp(firebaseConfig);
} catch (error) {
  if (error.code === 'app/duplicate-app') {
    app = getApp();
  } else {
    throw error;
  }
}

// Initialize services
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app);

// Initialize analytics only if it's supported (browser environment)
let analytics = null;
isSupported().then(yes => yes && (analytics = getAnalytics(app)));

export { app, auth, db, storage, functions, analytics }; 